<script lang="ts" setup>
// #滿版圖片
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData = ref()

if (props.data) {
  const img: Ref<Image> = ref(props.data.image)
  imgData.value = img.value
}
</script>

<template>
  <div class="area">
    <figure class="area__pic">
      <Nimg :src="imgData?.link" :title="imgData?.title" :alt="imgData?.alt" format="webp" />
      <figcaption class="area__caption">{{ imgData?.caption }}</figcaption>
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  &__pic {
    img {
      display: block;
      width: 100%;
    }
  }

  &__caption {
    font-size: toRem(16);
    padding-top: toRem(12);
  }
}
</style>
